import { render, staticRenderFns } from "./upload_page.vue?vue&type=template&id=29bea698&scoped=true&"
import script from "./upload_page.vue?vue&type=script&lang=js&"
export * from "./upload_page.vue?vue&type=script&lang=js&"
import style0 from "./upload_page.vue?vue&type=style&index=0&id=29bea698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bea698",
  null
  
)

export default component.exports